<div class="curtain">

<section class="component-modalDialog redesigned cuzk">
    <header>
        {{title}}
        <a class="closeModalDialog fa fa-close" (click)="close()" *ngIf="!loading"></a>
    </header>
    <div class="contentContainer scrollable nativeScrollbar inside">
        <div *ngIf="errorMessage" class="colorRed">
            <span>Došlo k chybě: {{errorMessage}}</span>
        </div>
        <div class="component-loadingBox" *ngIf="loading">
            <div class="spinner"></div>
            <p>Probíhá načítání dat...</p>
        </div>
        <form *ngIf="!loading" autocomplete="off">
            <div *ngIf="!downloadInProgress && (!cuzkCredentialsSaved || mode === 'HEADER' || wrongCredentials) && !tryDownload">

                <div class="col-7 no-height logo-cuzk">
                    <strong>Zadejte přihlašovací údaje k dálkovému přístupu</strong>
                </div>

                <div class="col-7">
                    <label for="cuzk-username" class="entry-label">Uživatelské jméno</label>
                    <input
                        type="text"
                        name="cuzk-username"
                        id="cuzk-username"
                        [(ngModel)]="loginData.cuzkUsername"
                        (ngModelChange)="onChangeUsername();"
                        autocomplete="cuzk-username"
                        required
                        autofocus>
                </div>

                <br>

                <div class="col-7">
                    <label for="cuzk-password" class="entry-label">Heslo</label>
                    <input
                        type="password"
                        name="cuzk-password"
                        id="cuzk-password"
                        [(ngModel)]="loginData.cuzkPassword"
                        (ngModelChange)="onChangePassword();"
                        autocomplete="one-time-code"
                        required>
                </div>

                <br>

                <div class="col-7" *ngIf="mode === 'HEADER'">

                    <legend>
                        <strong>Při automatické aktualizaci dat chcete:</strong>
                    </legend>

                    <fieldset>
                        <input
                            type="radio"
                            class="styled"
                            name="cuzk-download-personal-data"
                            id="cuzk-download-type-B"
                            (ngModelChange)="onChangeDownloadType();"
                            [(ngModel)]="loginData.cuzkDownloadPersonalData"
                            value="B">
                        <label for="cuzk-download-type-B" class="showAsCheckbox withLabel">
                            stahovat osobní údaje vlastníků parcel ve všech půdních blocích, ve smlouvách a v majetku
                            <ca-absolute-tooltip
                                content="V pachtovních smlouvách ve stavech platných, nepodepsaných platných, v návrhu a v podpachtovních smlouvách a směnách."
                                position="top-left"
                                type="icon-info">
                            </ca-absolute-tooltip>
                        </label>

                        <input
                            type="radio"
                            class="styled"
                            name="cuzk-download-personal-data"
                            id="cuzk-download-type-M"
                            (ngModelChange)="onChangeDownloadType();"
                            [(ngModel)]="loginData.cuzkDownloadPersonalData"
                            value="M">
                        <label for="cuzk-download-type-M" class="showAsCheckbox withLabel">
                            stahovat osobní údaje vlastníků parcel v mých půdních blocích, ve smlouvách a v majetku
                            <ca-absolute-tooltip
                                content="V pachtovních smlouvách ve stavech platných, nepodepsaných platných, v návrhu a v podpachtovních smlouvách a směnách."
                                position="top-left"
                                type="icon-info">
                            </ca-absolute-tooltip>
                        </label>

                        <input
                            type="radio"
                            class="styled"
                            name="cuzk-download-personal-data"
                            id="cuzk-download-type-A"
                            (ngModelChange)="onChangeDownloadType();"
                            [(ngModel)]="loginData.cuzkDownloadPersonalData"
                            value="A">
                        <label for="cuzk-download-type-A" class="showAsCheckbox withLabel">
                            stahovat osobní údaje všech vlastníků parcel
                        </label>

                        <input
                            type="radio"
                            class="styled"
                            name="cuzk-download-personal-data"
                            id="cuzk-download-type-N"
                            (ngModelChange)="onChangeDownloadType();"
                            [(ngModel)]="loginData.cuzkDownloadPersonalData"
                            value="N">
                        <label for="cuzk-download-type-N" class="showAsCheckbox withLabel">
                            nestahovat žádné osobní údaje
                        </label>

                    </fieldset>

                </div>

                <div class="textAlignCenter borderedSection" *ngIf="mode !== 'HEADER'">
                    <button class="button-primary" (click)="downloadPersonalData();">Stáhnout osobní údaje</button>
                </div>

                <div class="textAlignCenter borderedSection" *ngIf="mode !== 'HEADER'">
                    Potřebujete poradit? <a href="mailto:podpora@cleverassets.cz">Kontaktujte nás!</a>
                </div>
            </div><!-- login part end -->

            <div class="col-full" *ngIf="tryDownload && !downloadInProgress">
                <legend>
                    <strong>V aplikaci existují katastrální data bez osobních údajů. Zvolte následující možnost:</strong>
                </legend>

                <fieldset>
                    <input
                        type="radio"
                        class="styled"
                        name="cuzk-download-personal-data-actual"
                        id="cuzk-download-type-B-actual"
                        [(ngModel)]="actualDownloadType"
                        value="B">
                    <label for="cuzk-download-type-B-actual" class="showAsCheckbox withLabel">
                        stahovat osobní údaje vlastníků parcel ve všech půdních blocích, ve smlouvách a v majetku
                        <ca-absolute-tooltip
                            content="V pachtovních smlouvách ve stavech platných, nepodepsaných platných, v návrhu a v podpachtovních smlouvách a směnách."
                            position="top-left"
                            type="icon-info">
                        </ca-absolute-tooltip>
                    </label>

                    <input
                        type="radio"
                        class="styled"
                        name="cuzk-download-personal-data-actual"
                        id="cuzk-download-type-M-actual"
                        [(ngModel)]="actualDownloadType"
                        value="M">
                    <label for="cuzk-download-type-M-actual" class="showAsCheckbox withLabel">
                        stáhnout osobní údaje vlastníků parcel v mých půdních blocích, ve smlouvách a v majetku
                        <ca-absolute-tooltip
                            content="V pachtovních smlouvách ve stavech platných, nepodepsaných platných, v návrhu a v podpachtovních smlouvách a směnách."
                            position="top-left"
                            type="icon-info">
                        </ca-absolute-tooltip>
                    </label>

                    <input
                        type="radio"
                        class="styled"
                        name="cuzk-download-personal-data-actual"
                        id="cuzk-download-type-A-actual"
                        [(ngModel)]="actualDownloadType"
                        value="A">
                    <label for="cuzk-download-type-A-actual" class="showAsCheckbox withLabel">
                        stáhnout osobní údaje všech vlastníků parcel
                    </label>

                    <input
                        type="radio"
                        class="styled"
                        name="cuzk-download-personal-data-actual"
                        id="cuzk-download-type-N-actual"
                        [(ngModel)]="actualDownloadType"
                        value="N">
                    <label for="cuzk-download-type-N-actual" class="showAsCheckbox withLabel">
                        nestahovat žádné osobní údaje
                    </label>

                </fieldset>
            </div><!-- current download part end -->

            <div *ngIf="downloadInProgress" class="col-full">
                <p class="textAlignCenter overflowing">Probíhá stažení požadovaných osobních údajů.</p>
                <p class="textAlignCenter overflowing">Průběh stahování můžete sledovat v modulu <a routerLink="/cadastral-data/personal-data">Stažení osobních údajů</a>.</p>
                <p class="textAlignCenter overflowing">O skončení stahování budete informování.</p>
            </div><!-- download info part end -->
        </form><!-- loading box -->
    </div>
    <footer *ngIf="!loading">
        <a class="button-primary" *ngIf="canWrite && tryDownload && !downloadInProgress && !loading" (click)="downloadFirstPersonalData();">Stáhnout</a>
        <a class="button-primary" *ngIf="canEditCuzkSettings && mode === 'HEADER' && !tryDownload" (click)="save();">Uložit</a>
        <a class="button-secondary" (click)="close();">Zavřít</a>
    </footer>
</section>

</div><!-- curtain -->